module.exports = __webpack_public_path__ + "img/bg.ca950d1b.png";